export const GRID_BASE_SETTINGS_KEY = 'total_consumption';
export const COLUMNS_WIDTH_ELECTRIC_KEY = '_columns_width_electric';
export const COLUMNS_ORDER_ELECTRIC_KEY = '_columns_order_electric';
export const COLUMNS_VISIBILITY_ELECTRIC_KEY = '_columns_visibility_electric';
